import { throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpParams } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { ApiService } from '../../core/services/index';

@Injectable({ providedIn: 'root' })
export class assessmentService {

    constructor(private _api: ApiService) { }

    save(data) {
        return this._api.post(`${"assessment/save"}`, data)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }

    getUserCoinAssessments(data) {
        const { user_id, coin_id } = data;
        let httpParams = new HttpParams();
        httpParams = httpParams.append('user_id', user_id);
        httpParams = httpParams.append('coin_id', coin_id);
        return this._api.get(`${"assessment/coin/byuser?" + httpParams}`)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }


    getAllCoinAssessments(coinId) {
        return this._api.get(`${"assessment/coin/all/" + coinId}`,)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }


    getUserGivenAssessments(userId:string) {
        return this._api.get(`${"assessment/user/" + userId}`,)
            .pipe(
                map((res: any) => res),
                catchError((error: any) => throwError(() => error))
            );
    }
        
}

